(function(){
  var d=document;
  function $(s,r){return (r||d).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||d).querySelectorAll(s))}
  function store(k,v){try{if(v===undefined)return localStorage.getItem(k);localStorage.setItem(k,v)}catch(e){return null}}

  /* drawer */
  var drawer=$('[data-hcu-drawer]');
  function openD(){if(!drawer)return;drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');d.body.style.overflow='hidden';var c=$('.hcu-drawer__head button',drawer);c&&c.focus()}
  function closeD(){if(!drawer)return;drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');d.body.style.overflow=''}
  $$('[data-hcu-open-drawer]').forEach(function(b){b.addEventListener('click',openD)});
  $$('[data-hcu-close-drawer]').forEach(function(b){b.addEventListener('click',closeD)});
  d.addEventListener('keydown',function(e){if(e.key==='Escape'){closeD();zp&&zp.classList.remove('is-open')}});

  /* zip */
  var zb=$('[data-hcu-zip]'),zp=$('[data-hcu-zippop]'),zl=$('[data-hcu-zip-label]'),zf=$('[data-hcu-zipform]');
  var saved=store('hcu_zip'); if(saved&&zl) zl.textContent=saved;
  zb&&zb.addEventListener('click',function(e){e.stopPropagation();zp.classList.toggle('is-open');var i=$('input',zp);i&&i.focus()});
  zp&&zp.addEventListener('click',function(e){e.stopPropagation()});
  d.addEventListener('click',function(){zp&&zp.classList.remove('is-open')});
  zf&&zf.addEventListener('submit',function(e){e.preventDefault();var v=$('input',zf).value.trim();if(!/^\d{5}$/.test(v))return;store('hcu_zip',v);zl.textContent=v;zp.classList.remove('is-open')});

  /* search with department */
  var sf=$('[data-hcu-search]');
  sf&&sf.addEventListener('submit',function(e){
    var dept=$('[data-hcu-dept]',sf),q=$('#hcu-q',sf).value.trim();
    if(dept&&dept.value&&!q){e.preventDefault();location.href=dept.value}
    if(!dept||!dept.value){if(!q){e.preventDefault()}}
  });

  /* add to cart without leaving the page */
  var toast=$('[data-hcu-toast]'),tt;
  function showToast(html){if(!toast)return;toast.innerHTML=html;toast.classList.add('is-on');clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('is-on')},4000)}
  d.addEventListener('submit',function(e){
    var f=e.target; if(!f.classList||!f.classList.contains('hcu-addform')||!window.fetch)return;
    e.preventDefault(); var btn=$('button',f); btn.disabled=true; var old=btn.textContent; btn.textContent='Adding...';
    fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j})})
      .then(function(item){return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
        $$('[data-hcu-count]').forEach(function(n){n.textContent=c.item_count});
        d.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        showToast('<b>Added to cart</b><br>'+(item.product_title||'')+'<br><a href="/cart">View cart and check out</a>');
      })})
      .catch(function(err){showToast('<b>Could not add this item.</b><br>'+((err&&err.description)||'Please try again.'))})
      .then(function(){btn.disabled=false;btn.textContent=old});
  });

  /* search suggestions */
  (function(){
    var form=$('[data-hcu-search]'); if(!form||!window.fetch) return;
    var input=$('#hcu-q',form), box=d.createElement('div'); box.className='hcu-sugg'; box.setAttribute('role','listbox'); box.hidden=true; form.appendChild(box);
    var t, last='', ctrl;
    function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
    function img(u,w){if(!u)return '';return u+(u.indexOf('?')>-1?'&':'?')+'width='+w}
    function render(r,q){
      var qs=(r.queries||[]).slice(0,4), cs=(r.collections||[]).slice(0,3), ps=(r.products||[]).slice(0,6), h='';
      if(qs.length){h+='<div class="hcu-sugg__g">'+qs.map(function(x){return '<a class="hcu-sugg__q" href="'+esc(x.url)+'">&#128269; '+x.styled_text+'</a>'}).join('')+'</div>'}
      if(cs.length){h+='<div class="hcu-sugg__g"><div class="hcu-sugg__h">Departments</div>'+cs.map(function(x){return '<a class="hcu-sugg__q" href="'+esc(x.url)+'">'+esc(x.title)+'</a>'}).join('')+'</div>'}
      if(ps.length){h+='<div class="hcu-sugg__g"><div class="hcu-sugg__h">Products</div>'+ps.map(function(x){return '<a class="hcu-sugg__p" href="'+esc(x.url)+'"><span class="hcu-sugg__im">'+(x.image?'<img src="'+esc(img(x.image,120))+'" alt="" loading="lazy">':'')+'</span><span class="hcu-sugg__pt"><span class="hcu-sugg__tt">'+esc(x.title)+'</span><b>$'+Number(x.price).toFixed(2)+(x.available===false?' <em>Sold out</em>':'')+'</b></span></a>'}).join('')+'</div>'}
      h+='<a class="hcu-sugg__all" href="/search?type=product&q='+encodeURIComponent(q)+'">See all results for &ldquo;'+esc(q)+'&rdquo; &rsaquo;</a>';
      box.innerHTML=h; box.hidden=false;
    }
    input.addEventListener('input',function(){
      var q=input.value.trim(); clearTimeout(t);
      if(q.length<2){box.hidden=true;return}
      t=setTimeout(function(){
        if(q===last){box.hidden=false;return} last=q;
        if(ctrl&&ctrl.abort)ctrl.abort(); ctrl=window.AbortController?new AbortController():null;
        fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=query,collection,product&resources[limit]=6&resources[options][unavailable_products]=last',ctrl?{signal:ctrl.signal}:{})
          .then(function(r){return r.json()}).then(function(j){if(input.value.trim()===q)render(j.resources.results,q)}).catch(function(){});
      },180);
    });
    input.addEventListener('focus',function(){if(box.innerHTML&&input.value.trim().length>1)box.hidden=false});
    d.addEventListener('click',function(e){if(!form.contains(e.target))box.hidden=true});
    input.addEventListener('keydown',function(e){
      var links=Array.prototype.slice.call(box.querySelectorAll('a')); if(box.hidden||!links.length)return;
      var i=links.indexOf(d.activeElement);
      if(e.key==='ArrowDown'){e.preventDefault();(links[0]).focus()}
      if(e.key==='Escape'){box.hidden=true}
    });
    box.addEventListener('keydown',function(e){
      var links=Array.prototype.slice.call(box.querySelectorAll('a')),i=links.indexOf(d.activeElement);
      if(e.key==='ArrowDown'){e.preventDefault();if(links[i+1])links[i+1].focus()}
      if(e.key==='ArrowUp'){e.preventDefault();if(i>0)links[i-1].focus();else input.focus()}
      if(e.key==='Escape'){box.hidden=true;input.focus()}
    });
  })();

  /* recently viewed */
  (function(){
    var wrap=$('[data-hcu-recent]'); if(!wrap) return;
    var list=[]; try{list=JSON.parse(store('hcu_recent')||'[]')}catch(e){}
    var cur=wrap.dataset.exclude; list=list.filter(function(p){return p.h!==cur}).slice(0,6);
    if(!list.length) return;
    function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
    $('.hcu-row',wrap).innerHTML=list.map(function(p){var s=(p.p/100).toFixed(2).split('.');return '<div class="hcu-card"><a class="hcu-card__im" href="/products/'+esc(p.h)+'" tabindex="-1">'+(p.i?'<img src="'+esc(p.i)+'" alt="" loading="lazy">':'')+'</a>'+(p.v?'<div class="hcu-card__brand">'+esc(p.v)+'</div>':'')+'<a class="hcu-card__t" href="/products/'+esc(p.h)+'">'+esc(p.t)+'</a><div class="hcu-price"><sup>$</sup>'+Number(s[0]).toLocaleString('en-US')+'<sup>'+s[1]+'</sup></div><a class="hcu-add hcu-add--opt" style="margin-top:10px" href="/products/'+esc(p.h)+'">View item</a></div>'}).join('');
    wrap.hidden=false;
  })();
})();
